import React from 'react';

const BriefcaseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M20.25 14.15v4.098a2.25 2.25 0 01-2.25 2.25h-13.5a2.25 2.25 0 01-2.25-2.25V14.15M18 18.25h.75a2.25 2.25 0 002.25-2.25v-4.098a2.25 2.25 0 00-2.25-2.25h-13.5a2.25 2.25 0 00-2.25 2.25V16c0 1.242 1.008 2.25 2.25 2.25h.75m12-9V5.25A2.25 2.25 0 0015 3h-6a2.25 2.25 0 00-2.25 2.25v4.5m12 0h-12" 
    />
  </svg>
);

export default BriefcaseIcon;